import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { MeddraBrowserComponent } from '../../meddra-browser/meddra-browser.component';
import { CreateSignalSourcesPopUpComponent } from 'src/app/user/signals/signal-config/create-signal-sources-pop-up/create-signal-sources-pop-up.component';





interface ProductMeta {
  id?: string;
  status?: string;
  dibd?: string | null; // DIBD
  ibd?: string | null; // IBD
  producttype?: string;
  productName?: string;
}

interface Product {
  name?: string;
  id?:any;
}

@Component({
    selector: 'app-create-signal-popup',
    templateUrl: './create-signal-popup.component.html',
    styleUrls: ['./create-signal-popup.component.scss'],
    standalone: false
})
export class CreateSignalPopupComponent implements OnInit {
    backgroundColorScreen = "";
    buttonColor = "";
    titleText = "Create Signal";
    backgroundColorButton="";
    form!: FormGroup;
    today = new Date();
    uploadedFiles: File[] = [];
      //keys are lookuptype , assignTo :-  are property to which lookup need to be added
    lookups = [
      { key: "SignalStatus", assignTo: "SignalStatus" },
      { key: "signalClassification", assignTo: "signalClassification"},
      { key: "signalPriority", assignTo: "signalPriority" },
      // { key: "SignalSourcesV2", assignTo: "SignalSources" },
    ];
    SignalStatus:any;
    signalClassification:any;
    signalPriority:any;
    SignalSources:any;
  selectedMeddra: any;
  signalProducts: any[] = [];
selectedProduct: any;
metadata: any = null;
  UserRoleName: any;
    productMeta?: ProductMeta;
    productsDisplayed = [];
  products: Product[];
  activities: any[] = [];
selectedScheduleId: any = 'NONE';
showProductSelection: boolean = true;
EditingMode: boolean = false;


  constructor(private fb: FormBuilder,
      private dialogRef: MatDialogRef<CreateSignalPopupComponent>,
      private snackBar: MatSnackBar,
      public dialog: MatDialog,
      private localStorageSettings: LocalStorageSettingsService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private jsignalsService: JsignalService,
      private spinner: NgxUiLoaderService,
      private commonService: CommonService,
      private service: ReportingServiceService,
      private validate: validationmethod,
      private linkservice: ReportlinksserviceService,) { }

  ngOnInit(): void {
    this.buildForm();
    this.loadSignalSourcesFromSignalConfiguration();

      if (this.data?.mode === 'create') {
        this.form.get('signalCreationDate')?.setValue(new Date());
      }

      if (this.data?.mode === 'edit' && this.data?.signalData) {
        this.EditingMode = true;
      }

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton =  this.localStorageSettings.getSettings("ColorA");
    console.log("Reccevied Data inside Update Signal",this.data);
    this.getAllLookupValue();
    this.fetchUserRole();

      // Generic control flag
  if (this.data?.hideProductSelection) {
    this.showProductSelection = false;
    this.patchActivityContext(this.data.rowData);
  }

  //SignalType Decision 
   console.log("Signal Type Received",this.data?.signalType);
    
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onNext(){

  }

  buildForm(){
    this.form = this.fb.group({
      signalDescription: ['',[Validators.required, this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
      signalName: ['',[Validators.required, this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
      //  medicalConcept: ['', Validators.required],
      signalStatus: ['', Validators.required],

      classification: ['', Validators.required],
      // source: ['', Validators.required],
      secondarySource: [''],
      primarySource: ['', Validators.required],

      // signalPriority: [''],
      signalCreationDate: [{ value: null, disabled: true }], 
      signalDetectedDate: ['', Validators.required],

      justification: ['',[Validators.required, this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
      // type:['']
    });
  }
   openMedDraBrowser() {
  const dialogRef = this.dialog.open(MeddraBrowserComponent, {
    width: '95vw',
    height: '95vh',
    maxWidth: '95vw',
    panelClass: 'meddra-dialog',
    disableClose: true,
    autoFocus: false,
    data: {
      mode: 'select'
    }
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (!result) {
      return;
    }
      console.log('RAW RESULT:', result);
  console.log('TYPE:', typeof result);
  console.log('IS ARRAY:', Array.isArray(result));

  const item = result[0];

    // If single selection
    const displayValue = `${item.name}`;

    this.form.patchValue({
      medicalConcept: displayValue
    });

    // Optional: store full object separately if needed for submission
    this.selectedMeddra = result;
  });
}



    

  onFileSelected(event: any) {
    this.uploadedFiles = [...event.target.files];
  }
   removeFile(file: File) {
    this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
  }

  // onSubmit() {
  //   this.form.markAllAsTouched();
  //   if (this.form.invalid) return;

  //   const payload = {
  //     ...this.form.getRawValue(),
  //     // uploadedFiles: this.uploadedFiles,
  //     // readonlyData: this.data,
  //     pssId:this.selectedProduct?.pssId,
  //     activiyId:this.selectedProduct?.activityId,
  //     productId:this.selectedProduct?.productId,
  //     product: this.selectedProduct?.productName,
  //     activityScheduleID:this.selectedProduct?.scheduleId
  //   };
  //   console.log(payload);

  //     if (this.data?.mode === 'edit') {
  //       payload['signalId'] = this.data.signalData.signalId;
  //     }

  //   this.dialogRef.close(payload);
  // }

  onSubmit() {
  this.form.markAllAsTouched();
  if (this.form.invalid) return;

  const activityContext = this.selectedScheduleId || {};
  console.log("Selected Activity Context:", activityContext);

  const dnsName = this.localStorageSettings.getSettings("dnsName");
  const workspaceId = this.localStorageSettings.getSettings("WorkspaceId");

  const payload: any = {
    ...this.form.getRawValue(),

    // 🔹 Product always comes from product dropdown or from Record for which signal create (I.E From Review Activity)
    productId: this.selectedProduct?.id || null,
    product: this.selectedProduct?.name || null,

    // 🔹 Activity / PSS only if selected
    // Activity / PSS (works for both flows)
    pssId: activityContext?.pssId || null,
    activityId: activityContext?.activityId || null,
    activityScheduleID: activityContext?.scheduleId || null,
    pssVersion:this.data?.rowData?.version || null,

     signalType: this.data?.signalType || 'EXTERNAL',
     dnsid: dnsName,
     workspaceid: workspaceId,
  };

  // 🔹 Edit Mode
  // if (this.data?.mode === 'edit') {
  //   payload.signalId = this.data.signalData.signalId;
  // }

    // Product validation
  if (!payload.productId) {
    console.error("Product ID is missing. Submission blocked.");
    this.snackBar.open("Please select a product before submitting.", "Close", {
      duration: 3000,
    });
    return;
  }


  console.log("Final Payload:", payload);
  this.dialogRef.close(payload);
}

  onCancel() {
    this.dialogRef.close();
  }

  getAllLookupValue(){
    this.spinner.start();
     // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;
          this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
          this.spinner.stop();
        },
      });
    });
    this.spinner.stop();
  }

  loadSignalDetectedProducts(userRole:any,productId: string) {
  this.spinner.start();  
  this.jsignalsService.getSignalDetectedProducts(userRole,productId).subscribe({
    next: (res: any[]) => {
      this.signalProducts = res || [];

      if (this.signalProducts.length > 0) {
        // If Edit Mode → patch using signal data
  
          // Create mode → auto select first product
          // this.selectedProduct = this.signalProducts[0];
          // this.patchMetadata(this.selectedProduct);

          this.selectedScheduleId = "NONE";   // ← default to None
          this.metadata = null;             // ← show product meta section
      
        this.spinner.stop();
      } else {
        //  No products scenario
        this.metadata = null;
        this.spinner.stop();
      }
    },
    error: () => {
      this.signalProducts = [];
      this.metadata = null;
      this.spinner.stop();
     this.snackBar.open("Failed to load products for signal detection", "Close", {
        duration: 3000,
      });
    }
  });
}

onProductChange(product: any) {
  this.patchMetadata(product);

  this.selectedScheduleId = 'NONE';  
  this.metadata = null;

    // Load product meta (IBD/DIBD)
  this.loadMeta(product.name);

  // Load activities for this product
  // this.loadSignalDetectedProducts(this.UserRoleName, product.id);


}
patchMetadata(product: any) {
    if (!product || product === 'NONE' ) {
    // NONE selected → show only product meta
    this.metadata = null;
    return;
  }

  this.metadata = {
    strategyName: product.strategyName,
    version: product.version,
    productName: product.productName,
    activityName: product.activityName
  };
}

    fetchUserRole() {
    this.linkservice
      .fetchUserRole(
        this.localStorageSettings.getSettings("dnsName"),
        this.localStorageSettings.getSettings("AuthUsername")
      )
      .subscribe((res: any) => {
        console.log(res.roleName);
        this.UserRoleName = res.roleName;
        // this.loadSignalDetectedProducts(this.UserRoleName);
         this.loadProductList();
      });
  }


  patchForEdit(signal: any) {

  this.titleText = "Update Signal";

  //Select product
  this.selectedProduct = this.products.find(
    p => p.id === signal.productId
  );

  if (this.selectedProduct) {

    // Load meta
    this.loadMeta(this.selectedProduct.name);

    // Load activities for product
    // this.loadSignalDetectedProducts(this.UserRoleName, this.selectedProduct.id);

    // After activities load, select correct activity
    setTimeout(() => {
      const selectedActivity = this.signalProducts.find(
        p => p.scheduleId === signal.activityScheduleID
      );

        if (selectedActivity) {
          this.selectedScheduleId = selectedActivity;   
          this.patchMetadata(selectedActivity);
        } else {
          this.selectedScheduleId = 'NONE';
        }
      }, 300);
  }

  // if (this.selectedProduct) {
  //   this.patchMetadata(this.selectedProduct);
  // }

  //Remove fields not part of form (avoid error)
  const formKeys = Object.keys(this.form.controls);

  const dynamicPatch: any = {};

  formKeys.forEach(key => {
    if (signal.hasOwnProperty(key)) {
      dynamicPatch[key] = signal[key];
    }
  });

    if (signal.signalCreationDate) {
    this.form.get('signalCreationDate')?.setValue(
      new Date(signal.signalCreationDate)
    );
  }

  dynamicPatch.primarySource = signal.primarySourceId;
  dynamicPatch.secondarySource = signal.secondarySourceId;

  // 3️⃣ Patch everything dynamically
  this.form.patchValue(dynamicPatch);

}


   loadMeta(name: string) {
    this.productMeta = undefined; // clear old
    this.jsignalsService.getProductMetadata(name).subscribe((arr) => {
      const raw = arr.length ? arr[0] : {};
      this.productMeta = this.mapToMeta(raw);
     
    });
  }

   private mapToMeta(raw: any): ProductMeta {
    const clean = (v: any): string | null =>
      v == null || (typeof v === "string" && !v.trim()) ? null : v;
    const productName = clean(raw.product__v_name__v) || "";
    return {
      id: clean(raw.id),
      status: clean(raw.status__v),
      dibd: clean(raw.registration_date__v),
      ibd: clean(raw.international_birthdate__v),
      // safetyTitle: productName ? `${productName} Safety Strategy` : null,
      // safetyStrategyLink:  clean(raw.link__sys),
      producttype: clean(raw.object_type__v_name__v),
      productName:productName
    };
  }

   onProductSelected(prod: Product) {
    this.selectedProduct = prod;
    console.log(this.selectedProduct);
    this.loadMeta(prod.name!);
  }

  loadProductList(){
    this.jsignalsService.getProductList().subscribe({
  next: (response: any[]) => {
    try {
      // Validate response type before mapping
      if (!Array.isArray(response)) {
        throw new Error('Invalid response type: expected an array.');
      }

      // Map both id and name safely
      this.products = response.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          id: item.id,
          name: item.name
        } as Product;
      });

      // Initialize your displayed & selected arrays
      this.productsDisplayed = [...this.products];
      this.selectedProduct = this.products[0] || null;

    if (this.selectedProduct) {

        if (this.data?.mode === 'edit' && this.data?.signalData) {
          this.patchForEdit(this.data.signalData);
        } else {
          // this.selectedScheduleId = 'NONE';
          // this.metadata = null;

          this.loadMeta(this.selectedProduct.name!);
          // this.loadSignalDetectedProducts(this.UserRoleName, this.selectedProduct.id);
        }
      }
    } catch (error) {
      console.error(' Error while processing product list:', error);
      
    }
  },
  error: (err) => {
    console.error(' API Error while fetching product list:', err);
  },
});
  }

  patchActivityContext(row: any) {
  if (!row) return;

  this.selectedProduct = {
    id: row.productId,
    name: row.productName
  };

  this.metadata = {
    strategyName: row.pssName,
    version: row.version,
    productName: row.productName,
    activityName: row.activityName
  };

  this.selectedScheduleId = {
    scheduleId: row.scheduleId,
    activityId: row.activityId,
    pssId: row.pssId
  };

  this.loadMeta(row.productName);
}

loadSignalSourcesFromSignalConfiguration(){
  this.spinner.start();
    this.jsignalsService.getAllSignalSources().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.SignalSources = response;
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching signal sources:", error);
        this.snackBar.open("Failed to load signal sources", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
}

onCreateNewSourceClick(event: Event){
  event.stopPropagation(); // prevent dropdown selection behavior

   this.dialog.open(CreateSignalSourcesPopUpComponent, {
               maxWidth: "100vw",
               height: "40%",
               width: "60%",
               disableClose: true,
             })
           .afterClosed()
           .subscribe((result) => {
              console.log(result);
            this.loadSignalSourcesFromSignalConfiguration();
           });
}



}
